import { Component, Input, OnInit } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { OperatorFilterEnum } from '../../../models/filter-model';
import { PageEvent } from '@angular/material/paginator';
import { Utils } from 'app/components/utils/Utils';
import { UserFiscalDataModel } from 'app/models/user-fiscal-data-model';
import { Log } from 'app/core/logging/log';


@Component({
  selector: 'app-admin-customer',
  templateUrl: './admin-customer.page.html',
  styleUrls: ['./admin-customer.page.scss'],
})
export class AdminCustomerPage implements OnInit {

  customers: {
      content: any[],
      pageNumber: number,
      totalElements: number,
      size: number,
      last: boolean
    } = { totalElements: 50, size:0, pageNumber: 0, last: false, content: [] };

    fieldFilters: any[] = [];
    displayedColumns: string[] = ['companyName', 'cardId', 'email', 'phone'];

  constructor(    
    private restService: RestService,
    private appService: AppService,
    private dialog: MatDialog) { }

  ngOnInit() {

    this.fieldFilters.push({
      name: 'companyName',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: 'companyName'
    });
    this.fieldFilters.push({
      name: 'cardId	',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: 'cardId'
    });
    this.fieldFilters.push({
      name: 'email',
      type: 'text',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: 'Email'
    });
    this.fieldFilters.push({
      name: 'phone',
      type: 'number',
      multiple: false,
      value: '',
      values: [],
      options: null,
      label: 'N.Teléfono'
    });

    this.searchCustomers();
  }

  open(customer: UserFiscalDataModel) {
    this.dialog.open(CustomerModalContent, {
      panelClass: 'responsive-dialog',
      maxWidth: '95vw',
      data: { userFiscalData: customer }
    }).afterClosed().subscribe((data) => {
      if (!data) {
        return;
      }
      Log.debug('data', data);
      this.searchCustomers();
    });
  }

  setOpen(customer?: UserFiscalDataModel) {
    Log.debug('customer', {customer});
    this.open(Object.assign({}, customer));
  }
  
  mapAsFilters(fieldFilters:any[]){
    let filters = [];
    let map = [];
    map['date'] = OperatorFilterEnum.BETWEEN;
    map['datetime'] = OperatorFilterEnum.BETWEEN;
    map['time'] = OperatorFilterEnum.BETWEEN;
    map['text'] = OperatorFilterEnum.LIKE;
    map['select'] = OperatorFilterEnum.EQUALS;
    map['number'] = OperatorFilterEnum.LIKE;

    for(let fieldFilter of fieldFilters){
      if((fieldFilter.value != null && fieldFilter.value != '') || (fieldFilter.values != null && fieldFilter.values.length > 0)){
        filters.push({
          field: fieldFilter.name,
          operator: map[fieldFilter.type],
          value: fieldFilter.value,
          values: fieldFilter.values
        }); 
      }
    }
    return Utils.generateFilters(filters);
  }

  searchCustomers(){
    let filters = this.mapAsFilters(this.fieldFilters);
    let sort = '&sort=createdAt,desc';
    let pageSize = "&page=" + this.customers.pageNumber + '&size=' + this.customers.totalElements;
    
    this.restService.searchCustomer(filters + sort + pageSize).subscribe(result => {
      this.customers = result;
    });
  }

  
  /**
   * 
   * @param event example: { length: 155, pageIndex: 1, pageSize: 50, previousPageIndex: 0 }
   */
  onPageChange(event: PageEvent) {
      Log.debug('onPageChange', {event});
      this.customers.pageNumber = event.pageIndex;
      this.customers.totalElements = event.pageSize;
      this.searchCustomers();
  }

}



@Component({
  selector: 'app-customer-modal-content',
  templateUrl: './admin-customer-modal.component.html'
})
export class CustomerModalContent {
  userFiscalData: UserFiscalDataModel;
  isNew: boolean = false;

  constructor(
              public activeModal: MatDialogRef<CustomerModalContent>,
              @Inject(MAT_DIALOG_DATA) public data: { userFiscalData: UserFiscalDataModel },
              private restService: RestService,
              public appService: AppService) {
                this.userFiscalData = data?.userFiscalData;
              }

  ngOnInit() {
    this.isNew = this.userFiscalData.id ? false : true;
  }  

  confirm(){
    if(this.isNew){
      this.createCustomer();
    }else{
      this.updateCustomer();
    }
  }
  
  cancel() {
      this.activeModal.close();
  }

  createCustomer(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.createCustomer(this.userFiscalData).subscribe(result => {
      this.activeModal.close(this.userFiscalData);
    });
  }

  updateCustomer(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.updateCustomer(this.userFiscalData).subscribe(result => {
      this.activeModal.close(this.userFiscalData);
    });
  }

  deleteCustomer(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    this.restService.deleteCustomer(this.userFiscalData.id).subscribe(result => {
      this.activeModal.close(this.userFiscalData);
    });
  }

  
}
